import axios from "axios";
import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { UploadFileArgs } from "../schemas/files";

import { generateFileName } from "./utils";

export const usePostFile = () => {
  const client = useApiClient();
  return useMutation<{ objectUrl: string }, Error, UploadFileArgs>(async args => {
    const fileName = generateFileName(args);
    const data = {
      caption_language: args.language,
      content_type: args.file.type,
      file_name: fileName,
    };
    const preSignResponse = await client.postFile(data);
    const uploadUrl = preSignResponse?.upload_url;
    const uploadFields: Record<string, string> = preSignResponse?.upload_fields;
    const objectUrl = preSignResponse?.object_url;

    const formData = new FormData();
    Object.entries(uploadFields).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("file", args.file, fileName);

    await axios({ method: "POST", url: uploadUrl, data: formData, headers: { Accept: "application/json" } });

    return { objectUrl };
  });
};
